import { render } from "./XTabEdit.vue?vue&type=template&id=75383b0f&scoped=true"
import script from "./XTabEdit.vue?vue&type=script&lang=js"
export * from "./XTabEdit.vue?vue&type=script&lang=js"

import "./XTabEdit.vue?vue&type=style&index=0&id=75383b0f&lang=less&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.4.33_webpack@5.93.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75383b0f"]])

export default __exports__